import { ServerStackIcon } from '@heroicons/react/24/outline';
import {
  DistributionApplicationGroup,
  countLabel,
  environmentLabel,
  paletteIndex,
  productNames,
} from './technologyDistributionView';

const SERVER_CHIP = [
  'bg-sky-50 text-sky-950',
  'bg-emerald-50 text-emerald-950',
  'bg-amber-50 text-amber-950',
  'bg-violet-50 text-violet-950',
  'bg-cyan-50 text-cyan-950',
  'bg-rose-50 text-rose-950',
];

type TechnologyDistributionApplicationCardProps = {
  group: DistributionApplicationGroup;
  selected: boolean;
  onSelect: () => void;
  onOpenServer: (assetId: string) => void;
};

export function TechnologyDistributionApplicationCard({
  group,
  selected,
  onSelect,
  onOpenServer,
}: TechnologyDistributionApplicationCardProps) {
  const serverCount = new Set(group.placements.map((placement) => placement.asset.id)).size;
  const products = productNames(group.products);

  return (
    <article
      className={`flex h-full flex-col rounded-2xl border bg-white p-4 shadow-sm ${
        selected
          ? 'border-primary-400 ring-2 ring-primary-100'
          : 'border-secondary-200'
      }`}
    >
      <button
        type="button"
        aria-pressed={selected}
        onClick={onSelect}
        className="w-full text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400"
      >
        <span className="block truncate text-base font-semibold text-secondary-900">
          {group.applicationName}
        </span>
        {products ? (
          <span className="mt-1 block truncate text-xs text-secondary-500">{products}</span>
        ) : (
          <span className="mt-1 block text-xs text-secondary-400">Sem produto vinculado</span>
        )}
        <span className="mt-2 block text-sm text-secondary-600">
          {countLabel(serverCount, 'servidor', 'servidores')}
        </span>
      </button>

      <div className="mt-4 grid grid-cols-2 gap-2">
        {group.placements.map((placement) => (
          <button
            key={placement.hosting.id}
            type="button"
            onClick={() => onOpenServer(placement.asset.id)}
            className={`min-w-0 rounded-xl px-2.5 py-2 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 ${
              SERVER_CHIP[paletteIndex(placement.asset.id, SERVER_CHIP.length)]
            }`}
          >
            <span className="flex min-w-0 items-center gap-1.5 text-sm font-medium">
              <ServerStackIcon className="h-3.5 w-3.5 shrink-0 opacity-70" aria-hidden="true" />
              <span className="truncate">{placement.asset.name}</span>
            </span>
            <span className="mt-0.5 block truncate text-xs opacity-70">
              {environmentLabel(placement.hosting.environmentKind)}
              {placement.hosting.address ? ` · ${placement.hosting.address}` : ''}
            </span>
          </button>
        ))}
      </div>
    </article>
  );
}
